module.exports = __webpack_public_path__ + "images/bannerEN-b3c52a69324ecb96857ea408ddc1e170.png";